import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ToastrService } from 'ngx-toastr';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
interface Recommendation {
  confirmation: boolean;
  extension: boolean;
  promotion: boolean;
  increment: boolean;
  termination: boolean;
}

@Component({
  selector: 'app-rating-preview',
  templateUrl: './rating-preview.component.html',
  styleUrls: ['./rating-preview.component.scss'],
})
export class RatingPreviewComponent implements OnInit {

  checkType: any;
  companyID: any;
  year: any;
  loggedInUserRole: any
  employeedatas: any;
  userId: any;
  hrView: any;
  loggedInUserEmpCode: any
  probationCurrentLogUserType: any
  pmsYears: any;
  selectedYear: any;
  loggedInCompanyFiscalyear: any | null;
  confirmationProbationWhomSetup: any
  fromYear: any;
  toYear: any;
  loggedInUserId: any
  employee:any
  constructor(private dialogRef: MatDialogRef<RatingPreviewComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private config: Config, private encryptionService: EncryptionService,
    private httpService: HttpService, public dialog: MatDialog, private toastr: ToastrService) {
    console.log(data);
    this.checkType = data.type
    this.companyID = data.companyID;
    this.year = data.year;
    this.employeedatas = data;
    this.userId = data?.userId;
    this.hrView = data.hrView;
    this.employee=data?.employee;
    this.probationCurrentLogUserType = data?.probationCurrentLogUserType
  }
  buttonColorName: any;

  ngOnInit() {

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.confirmationProbationWhomSetup = this.httpService.confirmationProbationWhomSetup;
    this.getpmsyearlist();
  
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.companyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls
      // this.getTraits();
      this.getTraitsrating();
  
      this.getUploadSign();
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');

    }
  }



  closeModal() {
    this.dialogRef.close();
  }
  addFlag = false;
  addRating() {
    this.addFlag = true
  }

  ratingStandards: any[] = [];
  ratings: any
    lineManagerOrHODData: any = [];

  emailOfHrAdmin: any;
  firstnameOfHrAdmin: any;
  lastnameOfHrAdmin: any;
  companyHrId: any;
  hodComment: any;
  managerComment: any;
  hrComment: any;
  employeeComment: any;
  getProbationEmployeeDetails: any;
 
  getTraits() {
    this.httpService.callGetService(`${this.config.getProbationTraits}/${this.companyID}/${this.year}`).subscribe((res: any) => {


      this.ratingStandards = res.data;

      this.ratings = this.ratingStandards.map((elm: any) => {
      
        const matchData = this.traitsRatingGet?.ratingAsMap.find((e: any) =>Number(e.traitId )=== elm.id);
   

        return {
          ...elm,
          outstanding: matchData?.ratingName === 'outstanding' || null,
          veryGood: matchData?.ratingName === 'veryGood' || null,
          good: matchData?.ratingName === 'good' || null,
          average: matchData?.ratingName === 'average' || null,
          belowAverage: matchData?.ratingName === 'belowAverage' || null,
          ratingId: matchData?.ratingId || null,
          whoChangedForm: matchData?.whoChangedForm || null
        };
      });

          this.lineManagerOrHODData = this.traitsRatingGet?.probationDetailHistory.map((res: any) => {
          
            if (res?.recommendationComment &&
              (res.recommendationComment === 'confirmation' ||
                res.recommendationComment === 'extension' ||
                res.recommendationComment === 'promotion' ||
                res.recommendationComment === 'increment' ||
                res.recommendationComment === 'termination')) {
              this.recommendation[res.recommendationComment as keyof Recommendation] = true;
            }
            this.recommandationFrom = res?.recommendationComment || null
            this.hodComment = res?.hodComment || null
            this.managerComment = res?.managerComment || null
            this.hrComment = res?.hrComment || null
            this.employeeComment = res?.employeeComment || null
            return {
              ...res,
              emplCode: res ? res?.empCode || res?.empCode : null,
              probationExtensionByDay: res ? res?.probationExtensionByDay || res?.probationExtensionByDay : null,
              probationStatus: res ? res?.probationStatus || res?.probationStatus : null,
              reasonForExtension: res ? res.reasonForExtension : null,
              probationDetailId: res ? res.probationDetailId : null,
              dateOfConfirmation: res ? res.dateOfConfirmation : res.dateOfConfirmation,
              dateOfJoining: (res !== undefined && res?.doj !== null) ? res?.doj : res?.doj,
            }
          })

    })
  }

  @ViewChild('signatureLine') signatureLine!: ElementRef;
  showImage: any

  traitsRatingGet: any = []
  getTraitsrating() {
    this.httpService.callGetService(`${this.config.getPreViewTraitsRating}/${this.userId}/${this.companyID}/${this.selectedYear}`).subscribe((res: any) => {
      console.log(res.data);
      this.traitsRatingGet = res.data
this.getTraits();

    })
  }

  selectedRatings: any

  recommendation: Recommendation = {
    confirmation: false,
    extension: false,
    promotion: false,
    increment: false,
    termination: false
  };
  recommandationFrom: any
  selectOnlyOnerecommendation(item: keyof Recommendation) {
    Object.keys(this.recommendation).forEach(key => {
      this.recommendation[key as keyof Recommendation] = (key === item);

    });
    console.log(item);
    this.recommandationFrom = item
  }

  // ---------------------------------------------------------------------------------------------------------------------------------


  // __________________-------------------------------------------------------SignUpload------------------------------------------------------


  signfileNameForApiAppend: any;
  showSignBrowseBtn: boolean = false;
  isDraggingSign: boolean = false;
  isDisabledUploadPolicyBtnForSign: boolean = true;
  checkbackendDataForSign: any

  getUploadSign() {
    this.httpService.callGetService(this.config.getOfferLetter + this.companyID + '?fileFor=HODSIGNATURE&year=' + this.selectedYear)
      .subscribe((result: any) => {
        console.log(result.data);
        if (result.data != null) {
          this.checkbackendDataForSign = result.data;
          this.signfileNameForApiAppend = result.data;
          this.showSignBrowseBtn = true;

          // Set the image URL correctly
          this.showImage = `${this.config.downloadFile}${this.companyID}/${result.data}`;
        } else {
          this.signfileNameForApiAppend = '';
          this.showSignBrowseBtn = false;
          this.isDisabledUploadPolicyBtnForSign = true;
          this.showImage = null; // Clear the image if no data
        }
      });
  }

  // ... existing code ...



}